import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { SearchOutlined } from '@material-ui/icons';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { Button } from '@mui/material';
import { Stack } from '@mui/system';
import { DataGrid, GridColumns, GridRenderCellParams } from '@mui/x-data-grid';
import * as React from "react";
import { IDomainInDTO } from '../../repository/jago/model/input/IDomainInDTO';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import translations from '../../translations/i18next';
import ReduxLanguage from '../ReduxLanguage';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});


export interface ICustomerContractDomainsTableState {
}

export interface ICustomerContractDomainsTableProps extends WithStyles<typeof styles>{
  customerDomains: PaginatedDataDTO<IDomainInDTO>;
  tableColumns?: GridColumns<IDomainInDTO>;
  onRowClick?: (customerDomain: IDomainInDTO) => void;
  onFetchElementsOnPage: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  onRemovePlantFromContractRequest?: (domain: IDomainInDTO) => void;
  rowsPerPage: number;
  rowHeight?: number;
  disableSelectionOnClick?: boolean;
  isLoading?: boolean;
}

class CustomerContractDomainsTable extends React.Component<ICustomerContractDomainsTableProps, ICustomerContractDomainsTableState> {
  private defaultColumns: GridColumns<IDomainInDTO>;
  public render() {
    const { customerDomains, disableSelectionOnClick, onRowClick, tableColumns, rowHeight, onRemovePlantFromContractRequest } = this.props;
    this.defaultColumns = [
      {
        field: 'name',
        headerName: translations.t('gateways.name'),
        type: 'string',
        sortable: false,
        filterable: true,
        minWidth: 350,
        flex: 1,
        renderCell: (params: GridRenderCellParams<any>) => {
          const customerDomain = params.row;
          return (
            <div>
              <h3 style={{ margin: 0,  fontWeight: 'bold' }}>{customerDomain.hostname}</h3>
            </div>
        )}
      },
      ...(AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CONTRACTS_UPDATE) ? [{
        field: 'actions',
        headerName: translations.t('forms.actions'),
        renderCell: (params: any) => {
          return (
            <Button
              variant="contained"
              style={{
                backgroundColor: 'darkred',
                flexShrink: 0,
                marginRight: 20,
                width: 'fit-content',
                color: 'white',
                padding: 4,
                paddingLeft: 10,
                paddingRight: 10,
                fontWeight: 'bold'
              }}
              onClick={(e) => {e.stopPropagation(); onRemovePlantFromContractRequest(params.row)}}
            >
              <RemoveCircleOutlineIcon style={{ fontSize: 15 }}/>
              <h5 style={{ fontWeight: 'bold', margin: 0, marginLeft: 5 }} ><ReduxLanguage languageKey={"credits.removeCustomerPlantFromContract"} /></h5>
            </Button>
          )
        },
        type: 'string',
        sortable: false,
        minWidth: 200,
      }] : []),
    ];

    return (
      <DataGrid
        getRowId={(d) => d.id}
        rows={customerDomains.content || []}
        columns={tableColumns ? tableColumns: this.defaultColumns}
        rowHeight={rowHeight ? rowHeight: 55}
        onPageSizeChange={null}
        onPageChange={null}
        page={null}
        rowCount={null}
        pageSize={null}
        loading={this.props.isLoading}
        onRowClick={row => onRowClick ? onRowClick(row.row) : null}
        disableSelectionOnClick={disableSelectionOnClick}
        hideFooter={true}
        componentsProps={{
          pagination: {
            labelRowsPerPage: translations.t('forms.rowsPerPage')
          }
        }}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                <SearchOutlined style={{ alignSelf: 'center' }} />
                <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 0 }}><ReduxLanguage languageKey='credits.noCustomerDomainFindTitle' /></h3>
                <h4 style={{ textAlign: 'center', marginTop: 0 }}><ReduxLanguage languageKey='credits.noCustomerDomainFindDescription' /></h4>
              </div>
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 0 }}><ReduxLanguage languageKey='credits.noCustomerDomainFindTitle' /></h3>
              <h4 style={{ textAlign: 'center', marginTop: 0 }}><ReduxLanguage languageKey='credits.noCustomerDomainFindDescription' /></h4>
            </Stack>
          )
        }}
        sx={{
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
        }}
      />
    );
  }
}

export default withStyles(styles)(CustomerContractDomainsTable);